import React from 'react';

import { expValEquals } from '@confluence/feature-experiments';

import { FullPageEditorSideEffects } from './FullPageEditorSideEffects.tsx';
import type { FullPageEditorSideEffectsProps } from './FullPageEditorSideEffects.tsx';

/**
 * Conditionally renders the side effects component based on experiment flag.
 *
 * When enabled: Renders FullPageEditorSideEffects as a child component to isolate side effects
 * When disabled: Returns null (side effects remain in parent component for backward compatibility)
 *
 * This component serves as a bridge to enable/disable the optimization via experiment flag.
 * Experiment: platform_editor_isolate_side_effects_experiment
 */
export const ConditionalSideEffectsComponent: React.FC<FullPageEditorSideEffectsProps> = (
	props,
) => {
	if (!expValEquals('platform_editor_isolate_side_effects_experiment', 'isEnabled', true)) {
		return null;
	}

	return <FullPageEditorSideEffects {...props} />;
};
